import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Input from "../../../Input/Input";

function GlobalFilter({ setglobelFilter }) {
  const [value, setvalue] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "set_value", payload: value });
    setglobelFilter(value);
  }, [value]);

  // const handleKeyDown = (event) => {
  //   if (event.key === "F1") {
  //     event.preventDefault();
  //     document.querySelector(".globalfilterinputbox").focus();
  //   }
  // };
  // useEffect(() => {
  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);
  return (
    <Input
      EMTQuery=""
      checked={""}
      InputConfig=""
      className="globalfilterinputbox"
      value={value || ""}
      handleInputChange={(e) => setvalue(e.target.value)}
      name="Table Search (F1)"
      handleBlur={() => {}}
      type={"search"}
    />
  );
}

export default GlobalFilter;
